import { IAvailableContacts, IPromoInfoSchema } from '../../../types/promo';

interface IGetPromoLogoParams {
  promo: IPromoInfoSchema;
  avaliableContacts: IAvailableContacts;
  cianMortgage: boolean;
}

export const getPromoLogo = ({
  promo,
  avaliableContacts,
  cianMortgage,
}: IGetPromoLogoParams): string | null | undefined => {
  const hasManyContacts = avaliableContacts.builders.length + avaliableContacts.sellers.length > 1;

  if (hasManyContacts && !cianMortgage) {
    return null;
  }

  return promo.authorLogoUrl;
};
